import { render, staticRenderFns } from "./CountdownRedirect.vue?vue&type=template&id=ef246818&scoped=true"
import script from "./CountdownRedirect.vue?vue&type=script&lang=js"
export * from "./CountdownRedirect.vue?vue&type=script&lang=js"
import style0 from "./CountdownRedirect.vue?vue&type=style&index=0&id=ef246818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef246818",
  null
  
)

export default component.exports